import React from "react";

export default function PageShell({ title, subtitle, children }) {
  return (
    <main className="ema-page">
      <header className="ema-page-hero">
        <div className="ema-container">
          <p className="ema-page-kicker">École de la Magistrature</p>
          <h1 className="ema-page-title">{title}</h1>
          {subtitle ? <p className="ema-page-subtitle">{subtitle}</p> : null}
        </div>
      </header>

      <section className="ema-page-body">
        <div className="ema-container">
          <div className="ema-page-card">{children}</div>
        </div>
      </section>
    </main>
  );
}

